import { Component } from 'vue-property-decorator'

import ContactList from '@/modules/Contact/scripts/contacts-list'

@Component({})
export default class ContactListFromDashboard extends ContactList {
  async mounted () {
    this.onResize()
    await this.clearPage()
    this.getList()
  }
}
